module.exports = __webpack_public_path__ + "img/image-thumb-21.9a674046.jpg";